import RoomTourPage from "./pages/RoomTourPage";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useMatch } from "react-router-dom";
import { Box } from "@mui/material";

import SiteNavbar from "./components/SiteNavbar";

import LandingPage from "./pages/LandingPage";
import UploadPage from "./pages/UploadPage";
import ResultsPage from "./pages/ResultsPage";
import AboutUs from "./pages/AboutUs";
import StartYourDayPage from "./pages/StartYourDayPage";

import CreatorRadarPage from "./pages/CreatorRadarPage";
import CreativeOpportunitiesPage from "./pages/CreativeOpportunitiesPage";
import CreativeTechOpportunitiesPage from "./pages/CreativeTechOpportunitiesPage";

import RoomMatcherPage from "./pages/RoomMatcherPage";
import StudentArtistMissionPage from "./pages/StudentArtistMissionPage";
import ActualRoomMatcherPage from "./pages/ActualRoomMatcherPage";
import ArtistPaintingAnalyzerPage from "./pages/ArtistPaintingAnalyzerPage";
import ArtistOfferResponsePage from "./pages/ArtistOfferResponsePage";
import BuyerOfferResponsePage from "./pages/BuyerOfferResponsePage";
import ArtworkDetailPage from "./pages/ArtworkDetailPage";
import TryPaintingPage from "./pages/TryPaintingPage";

/* Commitments pages */
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SocialImpactPage from "./pages/SocialImpactPage";
import EnvironmentalSustainabilityPage from "./pages/EnvironmentalSustainabilityPage";


function ExternalRedirect({ to }) {
    React.useEffect(() => {
        window.location.replace(to);
    }, [to]);

    return null;
}



function AppLayout() {
    const isMuseum = !!useMatch("/gallery");
    const isGallery = !!useMatch("/artist/:artistSlug") || isMuseum;
    return (
        <>
            {!isGallery && <SiteNavbar />}

            <Box sx={{ pt: isGallery ? 0 : { xs: "78px", md: "82px" } }}>
                <Routes>
<Route path="/gallery/walk" element={<RoomTourPage />} />
<Route path="/gallery" element={<RoomTourPage />} />
                    <Route path="/try-art/:category/:artworkId" element={<TryPaintingPage />} />
                    {/* Main website */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/about" element={<AboutUs />} />

                    {/* Commitments */}
                    <Route
                        path="/commitments"
                        element={<Navigate to="/commitments/privacy-policy" replace />}
                    />
                    <Route
                        path="/commitments/privacy-policy"
                        element={<PrivacyPolicyPage />}
                    />
                    <Route
                        path="/commitments/social-impact"
                        element={<SocialImpactPage />}
                    />
                    <Route
                        path="/commitments/environmental-sustainability"
                        element={<EnvironmentalSustainabilityPage />}
                    />

                    {/* Simple redirects for legal / commitment page discovery */}
                    <Route
                        path="/privacy-policy"
                        element={<Navigate to="/commitments/privacy-policy" replace />}
                    />
                    <Route
                        path="/social-impact"
                        element={<Navigate to="/commitments/social-impact" replace />}
                    />
                    <Route
                        path="/environmental-sustainability"
                        element={<Navigate to="/commitments/environmental-sustainability" replace />}
                    />
                    <Route
                        path="/sustainability"
                        element={<Navigate to="/commitments/environmental-sustainability" replace />}
                    />

                    {/* Public SEO artwork pages */}
                    <Route
                        path="/artwork/:category/:slug/:id"
                        element={<ArtworkDetailPage />}
                    />
                    <Route
                        path="/artwork/:category/:id"
                        element={<ArtworkDetailPage />}
                    />

                    {/* Public SEO artist pages */}
                    <Route
                        path="/artist/:artistSlug"
                        element={<RoomTourPage />}
                    />

                    {/* Legacy upload/results pages */}
                    <Route path="/upload" element={<UploadPage />} />
                    <Route path="/results" element={<ResultsPage />} />

                    {/* Daily lifestyle / Art Radar page */}
                    <Route path="/startyourday" element={<StartYourDayPage />} />
                    <Route path="/StartYourDay" element={<Navigate to="/startyourday" replace />} />
                    <Route path="/StartYourDayPage" element={<Navigate to="/startyourday" replace />} />
                    <Route path="/art-radar" element={<Navigate to="/startyourday" replace />} />

                    {/* Creator Radar */}
                    <Route path="/creator-radar" element={<CreatorRadarPage />} />
                    <Route path="/creator-radar/:slug" element={<CreatorRadarPage />} />

                    {/* Opportunities */}
                    <Route
                        path="/creative-tech-opportunities"
                        element={<CreativeTechOpportunitiesPage />}
                    />
                    <Route
                        path="/artist-opportunities"
                        element={<Navigate to="/creative-tech-opportunities" replace />}
                    />
                    <Route
                        path="/art-opportunities"
                        element={<Navigate to="/creative-tech-opportunities" replace />}
                    />
                    <Route
                        path="/creative-opportunities"
                        element={<CreativeOpportunitiesPage />}
                    />

                    {/* Buyer room matcher */}
                    <Route
                        path="/artist-room-matcher"
                        element={<ActualRoomMatcherPage />}
                    />
                    <Route
                        path="/match-art"
                        element={<ExternalRedirect to="/artist-room-matcher" />}
                    />
                    <Route
                        path="/match-art-to-my-room"
                        element={<ExternalRedirect to="/artist-room-matcher" />}
                    />
                    <Route
                        path="/find-art"
                        element={<ExternalRedirect to="/artist-room-matcher" />}
                    />
                    <Route
                        path="/find-painting"
                        element={<ExternalRedirect to="/artist-room-matcher" />}
                    />
                    <Route
                        path="/room-matcher"
                        element={<RoomMatcherPage />}
                    />

                    {/* Artist upload / artist onboarding */}
                    <Route path="/artist-launch" element={<ExternalRedirect to="/artist-launch" />} />
                    <Route
                        path="/upload-painting"
                        element={<ExternalRedirect to="/artist-launch" />}
                    />
                    <Route
                        path="/upload-artwork"
                        element={<ExternalRedirect to="/artist-launch" />}
                    />
                    <Route
                        path="/painters"
                        element={<ExternalRedirect to="/artist-launch" />}
                    />
                    <Route
                        path="/artists"
                        element={<ExternalRedirect to="/artist-launch" />}
                    />
                    <Route path="/artist-upload" element={<ExternalRedirect to="/artist-studio/?workspace=upload#studio-workspace" />} />

                    {/* Artist painting / artwork analyser */}
                    <Route
                        path="/artist-painting-analyzer"
                        element={<ArtistPaintingAnalyzerPage />}
                    />
                    <Route
                        path="/artwork-analyzer"
                        element={<Navigate to="/artist-painting-analyzer" replace />}
                    />
                    <Route
                        path="/artist-artwork-analyzer"
                        element={<Navigate to="/artist-painting-analyzer" replace />}
                    />

                    {/* Secure artist offer response page */}
                    <Route
                        path="/artist-offer/:offerId/:token"
                        element={<ArtistOfferResponsePage />}
                    />

                    {/* Secure buyer counter-offer response page */}
                    <Route
                        path="/buyer-offer/:offerId/:token"
                        element={<BuyerOfferResponsePage />}
                    />

                    {/* Student / work with us */}
                    <Route
                        path="/student-artist-mission"
                        element={<StudentArtistMissionPage />}
                    />
                    <Route
                        path="/work-with-us"
                        element={<Navigate to="/student-artist-mission" replace />}
                    />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Box>
        </>
    );
}

function App() {
    return <Router><AppLayout /></Router>;
}

export default App;
